define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var PreDefinedShortcutsManager = require('web-agent-utils/PreDefinedShortcutsManager');
    var BaseCategoriesPanelViewController = require('web-agent-viewControllers/BaseCategoriesPanelViewController');

    var PreDefinedContentPanel = BaseCategoriesPanelViewController.extend({
        ControllerName: "PreDefinedContentPanel",
        applicationType: 'PreDefinedContentPanel',

        LPViewMap: {
            rowsPlaceholder: ".lpview_items_content",
            tableContentPlaceholder: '.lpview_table_placeholder'
        },

        initialize: function (constructorData) {
            this.modelController = constructorData.modelController;
            // if legacy then create object of skill key by skill name
            if (!this.useCannedResponsesACService) {
                this.createSkillList();
            }
        }, events: function () {
            if (this.useCannedResponsesACService) {
                this.bindModel({modelPath: "preDefinedContent", callback: this.updatePredefinedContent});
            }
        },
        render: function () {
        }
    });


    /**
     * Table Data Binder Functions. inherited from the base and extend with new functionality.
     * @type {Object}
     */
    PreDefinedContentPanel.prototype.dataBinder = _.merge({}, BaseCategoriesPanelViewController.prototype.dataBinder, {
        rowClicked: function (data, rowView) {
            if (data.isSection) {
                this.categoriesView.toggleCategory(data, rowView);
            }
            else {
                if (this.focusedVisitorId) {
                    this.viewEventsHandler.fireEvent({
                        appName: this.focusedVisitorId,
                        UIEvent: this.viewEventsHandler.eventType.PRE_DEFINED_CONTENT_SELECTED,
                        eventData: data.rowData,
                        deleteOnFire: true
                    });
                }
            }
        }
    });

    PreDefinedContentPanel.prototype.dataRenderer = {
        numberOfSections: function (data) {
            return data.length;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            var retVal = -1;

            if (data[sectionIndex].items.item.constructor === Array) {
                retVal = data[sectionIndex].items.item.length;
            } else {
                retVal = 1;
            }

            return retVal;
        },
        dataForSection: function (data, sectionIndex) {
            return {title: data[sectionIndex].title};
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var rowData;
            if (data[sectionIndex].items.item.constructor === Array) {
                rowData = data[sectionIndex].items.item[rowIndex];
            } else {
                rowData = data[sectionIndex].items.item;
            }

            var value = {text: '', details: '', hotkey: '', type: rowData.format, rowData: rowData, title: ''};
            if (rowData.format == "html") {
                value.details = this.sanitizeText(rowData.text).text;
            } else {
                value.details = rowData.text;
            }

            value.title = value.details;
            value.hotkey = PreDefinedShortcutsManager.getShortcutText ? PreDefinedShortcutsManager.getShortcutText(rowData.hotKey).toLowerCase() : '';
            value.text = rowData.title;
            rowData = null;
            return value;
        },
        filterRow: function (data, filterText) {
            if (!filterText) {
                return false;
            }

            var lowerFilterText = filterText.toLowerCase();

            if ((data.title && data.title.toLowerCase() == lowerFilterText) || (data.text && data.text.toLowerCase() == lowerFilterText)) {
                return false;
            }

            var split = lowerFilterText.split(' ');

            for (var index = 0; index < split.length; index++) {
                var partialTitle = data.title.toLowerCase().indexOf(split[index]) >= 0;
                var partialText = data.text.toLowerCase().indexOf(split[index]) >= 0;

                if (!partialTitle && !partialText) {
                    return true;
                }
            }

            return false;
        },
        getPropertiesForHighlight: function () {
            return {
                text: true,
                details: true
            };
        }
    };

    /**
     * populate the configuration property of the class using the inheritance. (based on the ViewController implementation.)
     */
    PreDefinedContentPanel.prototype.getConfiguration = function () {
        this.useCannedResponsesACService = lpTag.WebAgent.logicController.useCannedResponsesACService();
        return {
            cssClass: "preDefinedContentPanel",
            rootModelPath: "preDefinedContent." + this.skillId,
            useCannedResponsesACService: this.useCannedResponsesACService,
            textPrefix: "predefined_content",
            tableConfig: {
                rowTemplateFile: "LP_recommended_content_item.html",
                sectionTemplateFile: "LP_categories_widget_section.html",
                noDataTemplate: "LP_recommended_content_no_data.html",
                sectionOwnerIdTag: "categoryId",
                rootModelPath: "preDefinedContent." + this.skillId,
                preventSubmitByEnter: true
            }
        };
    };

    /**
     * the delegate for the refresh button.
     */
    PreDefinedContentPanel.prototype.updateDataCallback = function () {
        lpTag.WebAgent.cannedAnswersController.fetchData(this.chatId);
    };

    /**
     * Update the Visitor Id for the panel.
     * @param visitorId
     */
    PreDefinedContentPanel.prototype.updateVisitor = function (visitorId) {
        var oldVisitorId = this.focusedVisitorId;
        BaseCategoriesPanelViewController.prototype.updateVisitor.call(this, visitorId);
        this.rebindSkillsEvent(oldVisitorId, visitorId);
        this.rebindLanguageEvent(oldVisitorId, visitorId);
    };

    /**
     * the delegate for the content switch.
     */
    PreDefinedContentPanel.prototype.updateContent = function () {
        this.updateChatId();
        this.updatePredefinedContent();
    };

    PreDefinedContentPanel.prototype.updateChatId = function () {
        var newParticipantPath = lpTag.WebAgent.logicController.getParticipantPath(this.focusedVisitorId);
        this.chatId = lpTag.WebAgent.logicController.getLatestChatId(newParticipantPath);
        var skillIds = lpTag.WebAgent.logicController.getChatSkillIds(this.chatId);
        this.unbindEvents();
        this.skillId = (skillIds && skillIds.length) ? skillIds.join('_') : 'unSkillChat';
        this.configuration = this.getConfiguration();
        this.bindEvents();
    };

    /**
     * This method is invoked when the predefined content data is updated from the server or when we switch between visitors and there is a chance
     * that each one of them has a different language/skill and therefore different content.
     */
    PreDefinedContentPanel.prototype.updatePredefinedContent = function () {
        if (!this.focusedVisitorId) {
            return;
        }
        var focusedVisitorLang = lpTag.WebAgent.logicController.getVisitorPredefinedContentLang(this.focusedVisitorId, this.chatId);

        if (focusedVisitorLang) {
            var visitorPreDefinedContent = this.getPredefinedContentByLang(focusedVisitorLang);
            this.categoriesTable.updateTableSectionsStateModelData(visitorPreDefinedContent, this.getUiState());
            this.updateTabTitleByTableContent();
        }
    };


    /**
     * This method will return the array of predefined content in the given language
     * @param lang
     * @returns {Array}
     */
    PreDefinedContentPanel.prototype.getPredefinedContentByLang = function (lang) {
        var predefinedContentByLang = [];

        //TODO: check why we clone this -performance issue?
        var predefinedContent = this.useCannedResponsesACService ? lpUtils.cloneObject(this.getModelParam("preDefinedContent." + this.skillId)) : lpUtils.cloneObject(this.getModelParam("preDefinedContent"));
        if (predefinedContent) {
            if (this.useCannedResponsesACService && predefinedContent[lang]) {
                predefinedContentByLang = predefinedContent[lang];
            } else {
                predefinedContentByLang = this.filterBySkill(predefinedContent);
            }
        }
        return predefinedContentByLang;
    };

    /**
     * filter the content by skill.
     * @param predefinedContent
     * @returns {*}
     */
    PreDefinedContentPanel.prototype.filterBySkill = function (predefinedContent) {
        var predefinedContentFilterd = predefinedContent;
        if (!this.skillList) {
            this.createSkillList();
            if (!this.skillList) {
                return predefinedContentFilterd;
            }
        }
        // Get the skill name
        var skillName = this.getModelParam("participants.info." + this.focusedVisitorId + ".data.skill");
        //var skillName = this.getModelParam("participants.myEngagements."+this.focusedVisitorId+".participantInfo.skill");
        if (skillName) {
            // Convert the skill name to ID
            var skillId = this.skillList[skillName];
            if (skillId) {
                predefinedContentFilterd = [];
                for (var i = 0; i < predefinedContent.length; i++) {
                    if (predefinedContent[i].skills.skillId.indexOf(""+skillId) !== -1) {
                        predefinedContentFilterd.push(predefinedContent[i]);
                    }
                }
            }
        }
        return predefinedContentFilterd;
    };

    /**
     * For legacy sites we create a skill list of this agent so we can filter by skill
     */
    PreDefinedContentPanel.prototype.createSkillList = function () {
        var skillList = lpTag.WebAgent.agentController.getModelParam("agent.skillsInfo.skillInfo");
        if (skillList) {
            this.skillList = {};
            for (var i = 0; i < skillList.length; i++) {
                this.skillList[skillList[i].name] = skillList[i].id;
            }
        }
    };

    /**
     * rebind the skills to the bounded visitor.
     * @param oldVisitorId
     * @param newVisitorId
     */
    PreDefinedContentPanel.prototype.rebindSkillsEvent = function (oldVisitorId, newVisitorId) {
        // handling the skills.
        if (!this.useCannedResponsesACService) {
            if (oldVisitorId) {
                var oldParticipantPath = lpTag.WebAgent.logicController.getParticipantPath(oldVisitorId);

                this.unbindModel({
                    modelPath: 'participants.info.' + oldVisitorId + '.data.skill',
                    callback: this.updatePredefinedContent
                });
                this.unbindModel({
                    modelPath: oldParticipantPath + '.participantInfo.skill',
                    callback: this.updatePredefinedContent
                });
            }
            var newParticipantPath = lpTag.WebAgent.logicController.getParticipantPath(newVisitorId);

            this.bindModel({
                modelPath: 'participants.info.' + newVisitorId + '.data.skill',
                callback: this.updatePredefinedContent
            });
            this.bindModel({
                modelPath: newParticipantPath + '.participantInfo.skill',
                callback: this.updatePredefinedContent
            });
        }
    };

    /**
     * Update the Visitor's language for the panel.
     * @param oldVisitorId
     * @param newVisitorId
     */
    PreDefinedContentPanel.prototype.rebindLanguageEvent = function (oldVisitorId, newVisitorId) {
        this.unbindModel({
            modelPath: getLanguagePath(oldVisitorId),
            callback: this.updatePredefinedContent
        });
        this.bindModel({
            modelPath: getLanguagePath(newVisitorId),
            callback: this.updatePredefinedContent
        });

        function getLanguagePath(visitorId) {
            return lpTag.WebAgent.logicController.getParticipantDataPath(visitorId) + '.data.engagement.language';
        }
    };


    return PreDefinedContentPanel;

});
